import { JsonObject, JsonProperty } from 'json2typescript';

@JsonObject('KeywordsListItem')
export class KeywordsListItem {
  @JsonProperty('ean', String, true) ean: string = undefined;
  @JsonProperty('sku', String, true) sku: string = undefined;
  @JsonProperty('brandName', String, true) brandName: string = undefined;
  @JsonProperty('platform', String, true) platform: string = undefined;
  @JsonProperty('country', String, true) country: string = undefined;
  @JsonProperty('tags', [String], true) tags: string[] = undefined;
}
